import {images} from "config/index"
import {projectsLocalization} from "localization"
import React, {Component} from "react"
import {connect} from "react-redux"
import styled from "styled-components"
import Icon from "../../Icon/Icon";

class Tabs extends Component {
    setSelectedTab = val => {
        const {onTabChange} = this.props
        onTabChange(val)
    }

    componentWillMount() {
        this.setState({selectedTab: this.props.selected})
    }

    render() {
        const {selectedLanguage, selectedTab, firstTab, secondTab} = this.props
        const localization = projectsLocalization[selectedLanguage]

        return (
            <TabLabel lang={selectedLanguage}>
                <li>
          <span
              onClick={() => this.setSelectedTab(firstTab.value)}
              className={`tab ${firstTab.className} ${selectedTab === firstTab.value ? "active flex items-center gap-2" : " flex items-center gap-2"}`}
          >
                <Icon name={'data'}/>
              {localization[firstTab.value]}
          </span>
                </li>
                <li className={'progress-tab-item'}>
          <span
              onClick={() => this.setSelectedTab(secondTab.value)}
              className={`tab ${secondTab.className} ${selectedTab === secondTab.value ? "active flex items-center gap-2" : " flex items-center gap-2"}`}
          >
                         <Icon name={'progress'}/>
              {localization[secondTab.value]}
          </span>
                </li>
            </TabLabel>
        )
    }
}

const TabLabel = styled.ul`
  background-color: var(--color-dark-grey);
  border-radius: 20px;
  display: flex;
  li {
    position: relative;
    & + li {
      border-left: 1px solid #000;
    }
    span {
      color: var(--color-theme);
      cursor: pointer;
      font-size: ${props => (props.lang === "en" ? "13px" : "14px")};
      padding: 10px 16px;
      opacity: 0.5;
      transition: opacity 0.3s ease-in;
      gap: 6px;
      
      &.monitoring {
        padding-left: 32px;
        
        &:before {
          background-image: url(${images.icons.progress});
          left: 14px;
          width: 12px;
          background-size: 100%;
        }
      }
      
      svg{
          height: 15px;
          width: 15px;
      }
      
      &.feedback {
        padding-left: 32px;
        
        &:before {
          background-image: url(${images.icons.message});
          left: 10px;
          background-size: 100%;
        }
      }
      
      
      &:hover,
      &:focus,
      &.active {
        opacity: 1;
      }
    }
  }
`

export default connect(state => ({
    selectedLanguage: state.localizationReducers.selectedLanguage,
}))(Tabs)



// WEBPACK FOOTER //
// ./src/components/layouts/tabs/tabs.js